import React, { useState, useEffect, useRef } from "react";
import { Table, Button } from "reactstrap";

import { Link } from "react-router-dom";

import "react-datepicker/dist/react-datepicker.css";

import { PayrollClient } from "services";
import { NotificationManager } from "react-notifications";

import img1 from "assets/images/users/1.jpg";

import Box from './box.jsx'
import ShiftModalForm from "./ShiftModalForm";

import { getDateRange } from "./utils";

import { useTrackingCategories } from "../../Xero/Reports/tracking-categories/useTrackingCategories";

import { Trans, useTranslation } from "react-i18next";


const ShiftTable = ({ t, portalEmployee, employee_id, changer, setChanger, ...props }) => {

    const payrollClient = PayrollClient();

    const [payrollEmployees, setPayrollEmployees] = useState([]);
    const [public_holidays, setPublic_holidays] = useState(null);
    const [reload, setReload] = useState(false)

    const [localChanger, setLocalChanger] = useState({ 'dateoffset': 0, 'department': '', 'date': 'daily', 'searchq': '', 'pickedDate': '' })

    if (!setChanger) {
        setChanger = setLocalChanger
        changer = localChanger
    }

    useEffect(() => {
        window.localStorage.setItem('pickedDate', changer.pickedDate);
        window.localStorage.setItem('dateoffset', changer.dateoffset);
    }, [changer.pickedDate, changer.dateoffset]);

    useEffect(() => {
        const current_date = new Date(window.localStorage.getItem('pickedDate'))
        setChanger({
            ...changer, pickedDate: !isNaN(current_date.getTime()) ? current_date : new Date(),
            dateoffset: (parseInt(window.localStorage.getItem('dateoffset')) || 0)
        });

    }, [])

    const { i18n } = useTranslation();
    const dir = i18n.dir();

    function doReload() {
        setReload(!reload)
    }

    const addShiftData = useRef({ 'userId': '', 'date_from': '', 'date_to': '' })


    const fetchPayrollEmployees = async () => {
        if (employee_id) {
            return [await payrollClient.get(`employees/${employee_id}`)];
        }
        return await payrollClient.get('employees?include_all=true&status=Active');
    }

    const { data: trackingCategories } = useTrackingCategories(!portalEmployee);

    const getLabel = () => {
        if (!trackingCategories) {
            return
        } else {
            return trackingCategories[0] ? trackingCategories[0].Name : ""
        }
    }

    const filterEmployees = () => {

        const result = portalEmployee ? portalEmployee : payrollEmployees
        var res = result

        const label = getLabel()

        if (result) {
            if (label && changer.department) {
                res = result.filter(employee => employee.tracking[label] === changer.department)
            }

            if (changer.searchq) {
                const pattern = new RegExp(changer.searchq);
                res = res.filter(employee => pattern.test(employee.full_name))
            }

            return res
        }
        return result
        // return (changer.department && payrollEmployees && getLabel())? payrollEmployees.filter(employee => employee.tracking[getLabel()] === changer.department): payrollEmployees
    }


    const assignEmployeeShift = (employees, shiftsAssignment) => {
        const _employees = employees?.map(employee => {

            employee.shifts_assignment = [];

            shiftsAssignment?.map(shift => {

                if (employee.id == shift.employee) {
                    employee.shifts_assignment = [...employee.shifts_assignment, shift]
                }
            })

            return employee
        })
        setPayrollEmployees(_employees);
    }
    const fetchShiftAssignment = (employees) => {

        payrollClient
            .get('shift_assignments')
            .then(({ data }) => {
                assignEmployeeShift(employees, data);
            })
            .catch((err) => {
                NotificationManager.error(t('Error while getting list of Employees'));
            });

    }

    useEffect(() => {
        fetchPayrollEmployees().then(({ data }) => {
            fetchShiftAssignment(data);
        })
        // fetchShiftAssignment();
        payrollClient.get('public_holidays').then(data => { setPublic_holidays(data.data) })
        // Fetchdepartments()

    }, [reload])


    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    return (
        <div>

            <ShiftModalForm modal={modal} toggle={toggle} addShiftData={addShiftData} t={t} reload={doReload} />
            <div className="row pt-2 justify-content-end px-2">
                <Button color="secondary" className="" onClick={() => setChanger({ ...changer, dateoffset: 0, pickedDate: new Date() })}><Trans>Today</Trans></Button>
                <button className={dir + " btn mx-4 border-0 p-0 no-shadow is-rot"} style={{ background: "transparent" }} onClick={() => setChanger({ ...changer, dateoffset: changer.dateoffset - 1 })}><img src="/images/left-arrow.svg" style={{ width: "30px" }} /></button>
                <button className={dir + " btn border-0 p-0 no-shadow is-rot"} style={{ background: "transparent" }} onClick={() => setChanger({ ...changer, dateoffset: changer.dateoffset + 1 })}><img src="/images/right-arrow.svg" style={{ width: "30px" }} /></button>
                <div className="arrows-container">
                </div>
            </div>

            <div className="shiftsmanagement">
                {public_holidays &&
                    <Table
                        className="text-center shiftmt"
                        responsive
                        style={{ borderSpacing: "4px", borderCollapse: "separate", }}
                    >
                        <thead>

                            <tr className="border-0 m-0">
                                <th className="border-0 m-0" style={{ verticalAlign: "middle", whiteSpace: "break-space" }}>
                                    <Trans>Employee Name</Trans>
                                </th>
                                {
                                    getDateRange(changer.dateoffset, changer.pickedDate).map((day, index) => {
                                        return (
                                            <th className={"border-0 m-0" + (new Date(day[0]).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0) ? " is-today" : "") + (new Date(day[0]).setHours(0, 0, 0, 0) == new Date(changer.pickedDate).setHours(0, 0, 0, 0) && " is-picked")} key={index}>
                                                {day[0]}
                                                <span style={{ display: 'block' }}>
                                                    {day[1]}
                                                </span>
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {filterEmployees().map((employee, key) => {
                                return (
                                    <tr className="border-0 m-0" key={key} >
                                        <td className="border-0 text-left" style={{ whiteSpace: 'break-spaces', width: "200px", maxWidth: "250px" }}>
                                            <div className="row">
                                                <div className="col-2"><img
                                                    src={employee.employee_picture || img1}
                                                    width="29"
                                                    className="mr-1"
                                                /></div>
                                                <div className="col-10"><Link to={`/payroll/employees/${employee.id}`}> {employee.full_name} </Link></div>

                                            </div>
                                        </td>
                                        {
                                            getDateRange(changer.dateoffset, changer.pickedDate || new Date()).map((day, index) => {
                                                return (
                                                    <Box employee={employee} index={index} day={new Date(day[0])} public_holidays={public_holidays} key={`${employee.id}-${index}`} subk={`b-${employee.id}-${index}`} toggle={toggle} addShiftData={addShiftData} />
                                                )
                                            })
                                        }
                                    </tr>
                                )
                            })}


                        </tbody>
                    </Table>}
            </div>
        </div>
    );
};


export default ShiftTable;
